export default (() => {

    function validateFields (formElement) {
        if (formElement === undefined) {            
            return wealthify.error.throwError('form.checkFieldValidity', 'formElement must be defined');
        }

        // Will check of new-style AND old-style field components in form

        // Get closest field component to element in form
        // Will ignore if not part of web component
        const fieldComponents = new Set([...formElement.elements]
            .map(element => wealthify.dom.isNode(element) && element.closest('[data-field-component]'))
            .filter(element => element !== null)
        );
        
        // TODO: Remove support of old-style components
        // Get closest old-style field component using .getWrappingComponent()
        const deprecatedFieldComponents = new Set([...formElement.elements]
            .filter(element => element.getWrappingComponent)
            .map(element => element.getWrappingComponent())
        );

        const invalidFields = [...fieldComponents, ...deprecatedFieldComponents].filter(element => !element.disabledprop && !element.valid);

        return {
            valid: invalidFields.length === 0,
            invalidFields
        };
    }

    function validateFieldsAndRefocus (formElement) {
        const {
            valid, invalidFields
        } = validateFields(formElement);

        if (!valid) {
            _fireValidationAndRefocus(invalidFields);
        }

        return valid;
    }

    function _fireValidationAndRefocus (invalidFields) {
        invalidFields.forEach((field) => {
            // Requires support of new-style AND old-style field components
            // TODO: Remove support of old-style components
            const isLegacyFieldComponent = field.getWrappingComponent !== undefined && field.fireValidation !== undefined;

            if (isLegacyFieldComponent) {
                field.fireValidation();
            } else {
                field.validation.events.ToggleInteractedWith.dispatch();
                field.validation.events.FireValidation.dispatch();
            }
        });

        const scrollLocation = window.scrollY + invalidFields[0].getBoundingClientRect().top;

        invalidFields[0].focus();
        window.scrollTo({top: scrollLocation});
    }

    function getFormData (formElement) {
        if (formElement === undefined) {            
            return wealthify.error.throwError('form.getFormData', 'formElement must be defined');
        }

        let data = {};

        [...formElement.elements]
            .filter(element => element.id)
            .forEach(element => data[element.id] = element.value);
        
        return data;
    }

    function isDirty (formElement) {
        if (formElement === undefined) {            
            return wealthify.error.throwError('form.isDirty', 'formElement must be defined');
        }

        const fieldElements = new Set([...formElement.elements].map(element => (wealthify.dom.isNode(element) && element.closest('[data-field-component]')) || element.getWrappingComponent).filter(element => element));

        return [...fieldElements].some(element => element.isDirty);
    } 

    return {
        validateFields,
        validateFieldsAndRefocus,
        getFormData,
        isDirty,
    };

})();